export default {
  title: 'Synchro marque — Marques',
  subtitle:
    "Aperçu de tous les restaurants du groupe et de leurs fonctionnalités synchronisées. Seul l'administrateur du compte peut apporter des modifications.",
  alert: {
    message: 'Accès administrateur uniquement',
    description:
      "Les modifications du menu principal, des prix et des offres ne peuvent être effectuées que par l'administrateur du compte. Tous les établissements reçoivent les mises à jour automatiquement.",
  },
  locations: {
    title: 'Établissements',
    description: 'Tous les restaurants du groupe partageant le menu principal et les paramètres',
    locations_zero: '0 établissement',
    locations_one: '1 établissement',
    locations_other: '{{count}} établissements',
    synced: 'Synchronisé',
  },
  features: {
    title: 'Fonctionnalités synchronisées',
    description: 'Ces fonctionnalités sont contrôlées par les paramètres principaux',
    menus: {
      title: 'Menu principal',
      desription: 'Les articles, catégories et descriptions sont synchronisés dans tous les établissements',
    },
    smart_pricing: {
      title: 'Tarification intelligente',
      desription: 'Les règles et ajustements de prix sont synchronisés dans tous les établissements',
    },
    offers: {
      title: 'Offres et promotions',
      desription: 'Les offres, remises et promotions actives sont synchronisées dans tous les établissements',
    },
  },
};
